import { Phone } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { BrandCard } from "@/components/common/BrandCard";
import { Button } from "@/components/ui/button";
import { business, brands } from "@/data/site";

export default function Brands() {
  return (
    <div>
      <PageHeader
        eyebrow="Manufacturer resources"
        title="The brands behind your mobility"
        description="We deliver, service and support equipment from the most trusted names in the industry. Browse each manufacturer's products, manuals and official support resources."
      >
        <Button asChild variant="brand" size="lg">
          <a href={business.phoneHref}><Phone className="h-4 w-4" /> Ask about a brand</a>
        </Button>
      </PageHeader>

      <section className="section-py">
        <div className="mx-auto max-w-7xl container-px">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {brands.map((b, i) => (
              <Reveal key={b.slug} delay={(i % 3) * 0.06}>
                <BrandCard brand={b} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
